export default {
  field__account_number: 'Номер рахунку (IBAN)',
  field__account_holder: "Ім'я власника рахунку",
  field__bank_name: 'Назва банку',
  field__bank_ifsc_code: 'IFSC код банку',
  field__bank_code: 'Код банку',
  field__account_holder_address: 'Адреса власника рахунку',
  field__bank_address: 'Адреса банку',
  field__bic: 'BIC',
  field__purpose_of_payment: 'Призначення платежу',
  field__pay_id: 'PayID',
  field__card_last_four_digits: 'Останні чотири цифри картки',
  field__invoice_receipt_number: 'Номер квитанції інвойса',
};
